import { Menu, styled } from '@mui/material';
import { sanguine, spaceCadet, ultraMarine } from '../../../../../utils/colors';

const StyledMenu = styled(Menu)({
  marginTop: 8,

  '& .MuiMenu-list': {
    padding: 0,
  },

  '& .menuText': {
    fontSize: 14,
    lineHeight: '16px',
  },
  '& .displayName': {
    fontSize: 14,
    lineHeight: '20px',
    color: spaceCadet[800],
    fontWeight: 600,
  },
  '& .basicText': {
    fontSize: 12,
    lineHeight: '16px',
    color: spaceCadet[500],
  },
  '& .sectionLabel': {
    fontSize: 11,
    lineHeight: '16px',
    color: spaceCadet[500],
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
  },
  '& .wrapper': {
    margin: '8px 12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 2,
  },
  '& .divider': {
    backgroundColor: ultraMarine[100],
    marginTop: 4,
    marginBottom: 4,
  },
  '& .menuItem': {
    fontSize: 14,
    lineHeight: '16px',
    minHeight: 0,
  },
  '& .menuItem2': {
    margin: '4px 4px 8px 4px',
    padding: '4px 8px',
    borderRadius: 2,
    color: sanguine[500],
  },
  '& .powerSettings': {
    fontSize: 16,
    marginRight: 8,
  },
});

export default StyledMenu;
